<app-layout-header></app-layout-header>

<main class="default-layout__content">
    <router-outlet *ngIf="true"></router-outlet>
</main>

<app-layout-footer></app-layout-footer>

<nav class="mobile-bottom-nav d-lg-none" *ngIf="!hideMobileBottomNav" aria-label="Mobile bottom navigation">
    <a [routerLink]="['/search/Anywhere/rentals']"
        [queryParams]="{ dates: '', adults: 2, children: 0, infants: 0, dateFlexibility: 0 }"
        routerLinkActive="is-active" class="mobile-bottom-nav__item">
        <i class="fa-solid fa-compass"></i>
        <span>Browse</span>
    </a>

    <a [routerLink]="['/user/favorites']" routerLinkActive="is-active" class="mobile-bottom-nav__item">
        <i class="fa-solid fa-heart"></i>
        <span>Favorites</span>
    </a>

    <a [routerLink]="['/contactus']" routerLinkActive="is-active" class="mobile-bottom-nav__item">
        <i class="fa-solid fa-phone"></i>
        <span>Call</span>
    </a>

    <button type="button" class="mobile-bottom-nav__item mobile-bottom-nav__item--button"
        [class.is-active]="accountMenuOpen" (click)="toggleAccountMenu()" aria-label="Open account menu">
        <i class="fa-solid fa-user"></i>
        <span>Account</span>
    </button>

    <button type="button" class="mobile-bottom-nav__item mobile-bottom-nav__item--button" data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2" aria-label="Open menu">
        <i class="fa-solid fa-bars"></i>
        <span>Menu</span>
    </button>
</nav>

<div class="mobile-account-backdrop" *ngIf="accountMenuOpen" (click)="closeAccountMenu()"></div>
<section class="mobile-account-sheet" *ngIf="accountMenuOpen" role="dialog" aria-modal="true" aria-label="Account menu">
    <header class="mobile-account-sheet__header">
        <h3>Account</h3>
        <button type="button" class="mobile-account-sheet__close" (click)="closeAccountMenu()" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </header>

    <a [routerLink]="['/user/favorites']" class="mobile-account-sheet__link" (click)="closeAccountMenu()">
        <i class="fa-solid fa-heart"></i>
        <span>Favorites</span>
    </a>
    <a [routerLink]="['/user/bookings']" class="mobile-account-sheet__link" (click)="closeAccountMenu()">
        <i class="fa-solid fa-suitcase"></i>
        <span>Bookings</span>
    </a>
    <a *ngIf="loggedIn" [routerLink]="['/user/profile']" class="mobile-account-sheet__link"
        (click)="closeAccountMenu()">
        <i class="fa-solid fa-user"></i>
        <span>Profile</span>
    </a>
    <a *ngIf="!loggedIn" [routerLink]="['/auth/login']" class="mobile-account-sheet__link" (click)="closeAccountMenu()">
        <i class="fa-solid fa-right-to-bracket"></i>
        <span>Sign in</span>
    </a>
    <button *ngIf="loggedIn" type="button" class="mobile-account-sheet__link mobile-account-sheet__link--danger"
        (click)="logout()">
        <i class="fa-solid fa-right-from-bracket"></i>
        <span>Sign out</span>
    </button>
</section>